import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';

import { catchError, throwError } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

export const requestErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const snackBar = inject(MatSnackBar);

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401) {
        snackBar.open('Falha na autenticação. Tente novamente mais tarde.', 'Fechar', {
          verticalPosition: 'top',
          duration: 5000,
        });
      }

      return throwError(() => err);
    })
  );
};
